export const VISIT_ATTRIBUTION_TITLE = 'Visit Attribution';
export const SALES_ATTRIBUTION_TITLE = 'Sales Attribution';
